/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentInfoDto } from '../../models/document-info-dto';

export interface DocumentsGetDocumentsForPatient$Params {
  'x-trace-id'?: string;
  perId: number;
}

export function documentsGetDocumentsForPatient(http: HttpClient, rootUrl: string, params: DocumentsGetDocumentsForPatient$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentInfoDto>>> {
  const rb = new RequestBuilder(rootUrl, documentsGetDocumentsForPatient.PATH, 'get');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.path('perId', params.perId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentInfoDto>>;
    })
  );
}

documentsGetDocumentsForPatient.PATH = '/api/documents/person/{perId}';
